import axios from '../utils/axios';

export default function getSeekerFollowUpHistory(adminId, params) {
    return axios.get(`/admin/${adminId}/jobseeker-admin/job/admin/follow-up`, { params })
        .then(response => {
            // Map the new response structure to match the old structure
            if (response.data && response.data.data && response.data.data.data) {
                // Extract the data from the new structure
                const data = response.data.data.data;
                
                // Map the followups to match the old structure
                const mappedFollowups = data.last10Followups.map(followup => ({
                    id: followup.id,
                    jobid: followup.jobId,
                    followup_date: followup.followupDate.split('T')[0], // Convert ISO date to YYYY-MM-DD
                    status: followup.status,
                    recruiter_action_id: followup.recruiterActionId
                }));
                
                // Return the mapped structure to match the old format
                return {
                    data:{
                        data: {
                            seekerId: data.seekerId,
                            seekerName: data.seekerName,
                            seekerEmail: data.seekerEmail,
                            isProMember: data.isProMember,
                            remainingFollowups: data.remainingFollowups,
                            last10Followups: mappedFollowups
                        }
                    }
                };
            }
            return response;
        })
        .catch(err => {
            console.error(err);
            return err;
        });
};
